import { render } from "./PanelsContent.vue?vue&type=template&id=af862d0c"
import script from "./PanelsContent.vue?vue&type=script&lang=js"
export * from "./PanelsContent.vue?vue&type=script&lang=js"

import "./PanelsContent.vue?vue&type=style&index=0&id=af862d0c&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__